<div class="nav-bar-container navbottom">
  <div (click)="onSideNavSelect()">
    <!-- <a class="material-icons nav-bar-icon nav-bar-icon" title="User Search" (click)="onNavigate('user-search')">search</a> -->
    @if (innerWidth <= 767) {
      <a class="material-icons nav-bar-icon nav-bar-icon" title="Menu" id="nav-bar-menu-link">menu</a>
    }
    <!-- <a class="material-icons nav-bar-icon nav-bar-icon" title="My Profile" routerLinkActive="nav-bar-active-link" [routerLink]="['/my-profile']">account_circle</a> -->
    @if (myProfileImageSafe && innerWidth <= 767) {
      <div class="nav-bar-photo-container">
        <a class="nav-bar-profile-link" title="My Profile" routerLinkActive="nav-bar-profile-active" [routerLink]="['/my-profile']">
          <img class="nav-bar-profile-photo"
            [src]="myProfileImageSafe"
            alt="My Profile">
          </a>
        </div>
      }
      @if (!myProfileImageSafe || innerWidth > 767) {
        <a class="material-icons nav-bar-icon nav-bar-icon menu" title="My Profile" routerLinkActive="nav-bar-active-link" [routerLink]="['/my-profile']">account_circle</a>
      }
      @if (isSupervisor || isAdmin || isDeveloper) {
        <a  class="material-icons nav-bar-icon nav-bar-icon"   title="Manage Direct Report(s)"    (click) = "AddEmployee()"  [routerLink]="['/directreports']"  routerLinkActive="nav-bar-active-link" > group_add  </a>
      }
      <a class="material-icons nav-bar-icon nav-bar-icon" title="Contacts List" routerLinkActive="nav-bar-active-link" [routerLink]="['/contact-list']">supervised_user_circle</a>
      <a class="material-icons nav-bar-icon nav-bar-icon" title="User Search" routerLinkActive="nav-bar-active-link" [routerLink]="['/user-hist']">search</a>
      <a class="material-icons nav-bar-icon nav-bar-icon" title="Phone Directory" routerLinkActive="nav-bar-active-link" [routerLink]="['/phonelist']" >  book  </a>
      <a class="material-icons nav-bar-icon nav-bar-icon" title="Help" target="_blank" routerLinkActive="nav-bar-active-link" href="https://cityofphoenix.sharepoint.com/sites/avn-tech/SitePages/Aviation-FAQ.aspx">  help  </a>
      @if (isDeveloper) {
        <a class="material-icons nav-bar-icon nav-bar-icon" title="Admin Panel" routerLinkActive="nav-bar-active-link" [routerLink]="['/adminpanel']" > admin_panel_settings  </a>
      }
    </div>
    <div (click)="onSideNavSelect()" class="navbottom">
      <a class="material-icons nav-bar-icon" title="Log Out" (click)="onLogout()">logout</a>
    </div>
  </div>
